
(function ($) {

    const MENU_CONTAINER_SELECTOR = '#mobile_main_menu_container';

    $(MENU_CONTAINER_SELECTOR + ' .menu-item-has-children').attr('aria-expanded', false);
    $(MENU_CONTAINER_SELECTOR + ' .menu-item-has-children').attr('aria-haspopup', true);

    $(MENU_CONTAINER_SELECTOR).on('click', 'a', function (ev) {

        if (!$(this).closest('.menu-item').hasClass('menu-item-has-children')) return true;
        ev.preventDefault();

        $(MENU_CONTAINER_SELECTOR + ' .menu-item').not($(this).parents('.menu-item')).removeClass('menu-open');
        $(MENU_CONTAINER_SELECTOR + ' .menu-item').not($(this).parents('.menu-item')).attr('aria-expanded', false);

        if ($(this).closest('.menu-item').hasClass('menu-open')) {
            $(this).closest('.menu-item').removeClass('menu-open');
            $(this).closest('.menu-item').attr('aria-expanded', false);
            $(this).closest('.menu-item').find('menu-open').removeClass('menu-open');
            $(this).closest('.menu-item').find('menu-open').attr('aria-expanded', false);
        } else {
            $(this).closest('.menu-item').addClass('menu-open');
            $(this).closest('.menu-item').attr('aria-expanded', true);
        }

    });


})(jQuery);